import { render, staticRenderFns } from "./ProgramsTable.vue?vue&type=template&id=31890876&scoped=true&"
import script from "./ProgramsTable.vue?vue&type=script&lang=js&"
export * from "./ProgramsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsTable.vue?vue&type=style&index=0&id=31890876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31890876",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VIcon,VTooltip})
